@import 'styles/mixins';
@import 'styles/blaze/mixins';

.counterWrapper {
  position: absolute;
  right: 2px;
  top: 4px;

  .counter {
    color: var(--light-80);
    background-color: var(--dark-80);
  }
}

.heading {
  display: flex;
  align-items: center;
  gap: 6px;
}

.footer {
  display: flex;
  padding: 0 16px 20px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  background: var(--light-80);
}

.seeAll {
  margin-left: auto;
}

.createCommentButton {
  @include z-index(heaven);
  @include blur(35px);
  background: var(--light-60);
  box-shadow: 0px 8px 47px 0px rgba(0, 0, 0, 0.4);
  padding: 15px;
  position: fixed;
  bottom: 0;
  width: 100%;
  pointer-events: all;
}
